import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UsuarioServiceProvider } from '../index.providers';

@Injectable()
export class IdByBrandInterceptor implements HttpInterceptor {
  constructor(private up: UsuarioServiceProvider) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token: string = localStorage.getItem("token");
    let modifiedReq: HttpRequest<any> = req;

    if (token) {
      let data_usuario = JSON.parse(localStorage.getItem("user_data"));

      const workstation = {
        platform: data_usuario?.onboarding ? "onboarding" : "training",
        platform_id: data_usuario?.current_platform?.id,
        workspace: data_usuario?.workspace?.slug,
        workspace_id: data_usuario?.workspace?.id,
        subworkspace: data_usuario?.module?.slug,
        subworkspace_id: data_usuario?.module?.id,
      }

      if (req.method === 'GET') {
        modifiedReq = req.clone({
          params: (req.params || new HttpParams())
          .set('workstation', JSON.stringify(workstation))
          // .set('platform', workstation.platform)
          // .set('platform_id', workstation.platform_id)
          // .set('workspace', workstation.workspace)
          // .set('workspace_id', workstation.workspace_id)
          // .set('subworkspace', workstation.subworkspace)
          // .set('subworkspace_id', workstation.subworkspace_id)
        });

      } else {
        let originalBody = req.body;
        // console.log("originalBody",typeof req.body, req.body )

        if(typeof req.body === "string") {
          try {
            const parseBody = JSON.parse(req.body);
            originalBody = parseBody;
          } catch (error) {
            console.log(error)
          }
        };

        const body = { ...originalBody,
          workstation : {
            platform: workstation.platform,
            platform_id: workstation.platform_id,
            workspace: workstation.workspace,
            workspace_id: workstation.workspace_id,
            subworkspace: workstation.subworkspace,
            subworkspace_id: workstation.subworkspace_id,
          }
        };
        modifiedReq = req.clone({ body });
      };
    };

    return next.handle(modifiedReq);
  }
}
